import Repository from '../axios'
import {defaultPagination} from "../constants/config";
import staff from "../apis/staff";

const  resource = "/supplier/saq";
export default {

  createManufactureSite(payload){
    return Repository.post(`${resource}/sites`, payload)
  },
  getManufactureSiteStatus(id) {
    return Repository.get(`${resource}/manufacture/get-status/${id}`)
  },
  getAllManufacturerSites(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}/sites?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },

  getCountryCodes() {
    return Repository.get('supplier/country-code')
  },

  getManufactureDetails(id) {
    return Repository.get(`${resource}/sites/${id}`)
  },
  updateManufactureDetails(id, payload) {
    return Repository.put(`${resource}/sites/${id}`, payload)
  },

  getManufactureEmployeeDetails(id) {
    return Repository.get(`${resource}/manufacture/employees/${id}`)
  },
  CreateManufactureEmployeeDetails(payload) {
    return Repository.post(`${resource}/manufacture/employees`, payload)
  },
  UpdateManufactureEmployeeDetails(id, payload) {
    return Repository.put(`${resource}/manufacture/employees/${id}`, payload)
  },

  getManufactureSiteDetails(id) {
    return Repository.get(`${resource}/manufacture/sites/${id}`)
  },
  CreateManufactureSiteDetails(payload) {
    return Repository.post(`${resource}/manufacture/sites`, payload)
  },
  UpdateManufactureSiteDetails(id, payload) {
    return Repository.put(`${resource}/manufacture/sites/${id}`, payload)
  },

  getManufactureQualityDetails(id) {
    return Repository.get(`${resource}/manufacture/qualities/${id}`)
  },
  UpdateManufactureQualityDetails(id, payload) {
    return Repository.put(`${resource}/manufacture/qualities/${id}`, payload)
  },
  CreateManufactureQualityDetails(payload) {
    return Repository.post(`${resource}/manufacture/qualities`, payload)
  },
// Environment API
  getManufactureEnvironmentDetails(id) {
    return Repository.get(`${resource}/manufacture/environmentals/${id}`)
  },
  UpdateManufactureEnvironmentDetails(id, payload) {
    return Repository.put(`${resource}/manufacture/environmentals/${id}`, payload)
  },
  CreateManufactureEnvironmentDetails(payload) {
    return Repository.post(`${resource}/manufacture/environmentals`, payload)
  },

  // Ethical API
  getManufactureEthicalDetails(id) {
    return Repository.get(`${resource}/manufacture/ethicals/${id}`)
  },
  UpdateManufactureEthicalDetails(id, payload) {
    return Repository.put(`${resource}/manufacture/ethicals/${id}`, payload)
  },
  CreateManufactureEthicalDetails(payload) {
    return Repository.post(`${resource}/manufacture/ethicals`, payload)
  },

  // Allergens API
  getManufactureAllergensDetails(id) {
    return Repository.get(`${resource}/manufacture/allergens/${id}`)
  },
  UpdateManufactureAllergensDetails(id, payload) {
    return Repository.put(`${resource}/manufacture/allergens/${id}`, payload)
  },
  CreateManufactureAllergensDetails(payload) {
    return Repository.post(`${resource}/manufacture/allergens`, payload)
  },

  // HCCPS API
  getManufacturehaccpsDetails(id) {
    return Repository.get(`${resource}/manufacture/haccps/${id}`)
  },
  UpdateManufacturehaccpsDetails(id, payload) {
    return Repository.put(`${resource}/manufacture/haccps/${id}`, payload)
  },
  CreateManufacturehaccpsDetails(payload) {
    return Repository.post(`${resource}/manufacture/haccps`, payload)
  },

  // PEST API
  getManufacturePestDetails(id) {
    return Repository.get(`${resource}/manufacture/pests/${id}`)
  },
  UpdateManufacturePestDetails(id, payload) {
    return Repository.put(`${resource}/manufacture/pests/${id}`, payload)
  },
  CreateManufacturePestDetails(payload) {
    return Repository.post(`${resource}/manufacture/pests`, payload)
  },

  // Transport API
  getManufactureTransportDetails(id) {
    return Repository.get(`${resource}/manufacture/transtos/${id}`)
  },
  UpdateManufactureTransportDetails(id, payload) {
    return Repository.put(`${resource}/manufacture/transtos/${id}`, payload)
  },
  CreateManufactureTransportDetails(payload) {
    return Repository.post(`${resource}/manufacture/transtos`, payload)
  },

  // Health & Safety API
  getManufactureHealthAndSafetyDetails(id) {
    return Repository.get(`${resource}/manufacture/healsafes/${id}`)
  },
  UpdateManufactureHealthAndSafetyDetails(id, payload) {
    return Repository.put(`${resource}/manufacture/healsafes/${id}`, payload)
  },
  CreateManufactureHealthAndSafetyDetails(payload) {
    return Repository.post(`${resource}/manufacture/healsafes`, payload)
  },

  // Authenticity and traceability API
  getManufactureAuthenticityAndTraceabilityDetails(id) {
    return Repository.get(`${resource}/manufacture/authtracs/${id}`)
  },
  UpdateManufactureAuthenticityAndTraceabilityDetails(id, payload) {
    return Repository.put(`${resource}/manufacture/authtracs/${id}`, payload)
  },
  CreateManufactureAuthenticityAndTraceabilityDetails(payload) {
    return Repository.post(`${resource}/manufacture/authtracs`, payload)
  },

  // Hygienes API
  getManufactureHygienesDetails(id) {
    return Repository.get(`${resource}/manufacture/hygienes/${id}`)
  },
  UpdateManufactureHygienesDetails(id, payload) {
    return Repository.put(`${resource}/manufacture/hygienes/${id}`, payload)
  },
  CreateManufactureHygienesDetails(payload) {
    return Repository.post(`${resource}/manufacture/hygienes`, payload)
  },

};
